import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { Link } from "gatsby"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { getQualifiedURLOrPath, isRelativePath } from "../../../utils/url"
import { logAnalyticsEvent } from "../../../utils/analytics"

import Icon from "../icon"
import { InlineText } from "../../Typography/Typography"

import {
  icon,
  noHoverStyle as noHoverStyles,
  smartLink,
} from "./styles.module.scss"

const getNewTabProps = (newTab) =>
  newTab ? { target: "_blank", rel: "noopener noreferrer" } : {}

const logClickEvent = (clickEvent) =>
  clickEvent ? logAnalyticsEvent(clickEvent.name, clickEvent.properties) : null

const Chevron = () => (
  <InlineText brand>
    <Icon icon={faChevronRight} className={classNames(icon)} />
  </InlineText>
)

function SmartLink({
  to,
  newTab,
  children,
  clickEvent,
  chevron,
  disabled,
  onDisabledClick,
  noHoverStyle,
  ...otherProps
}) {
  const qualified = getQualifiedURLOrPath(to)
  const internal = isRelativePath(qualified)

  const handleClick = disabled
    ? (e) => {
        e.preventDefault()
        onDisabledClick()
      }
    : () => logClickEvent(clickEvent)

  return internal ? (
    <Link
      tabIndex={0}
      className={classNames(smartLink, { [noHoverStyles]: noHoverStyle })}
      to={encodeURI(qualified)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...getNewTabProps(newTab)}
      data-gatsby-link
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...otherProps}
      onClick={handleClick}
    >
      {children}
      {chevron && <Chevron />}
    </Link>
  ) : (
    <a
      tabIndex={0}
      className={classNames(smartLink, { [noHoverStyles]: noHoverStyle })}
      href={encodeURI(qualified)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...getNewTabProps(newTab)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...otherProps}
      onClick={handleClick}
    >
      {children}
      {chevron && <Chevron />}
    </a>
  )
}

SmartLink.propTypes = {
  to: PropTypes.string.isRequired,
  newTab: PropTypes.bool,
  clickEvent: PropTypes.shape({
    name: PropTypes.string,
    properties: PropTypes.object,
  }),
  chevron: PropTypes.bool,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  onDisabledClick: PropTypes.func,
  noHoverStyle: PropTypes.bool,
}
SmartLink.defaultProps = {
  newTab: false,
  chevron: false,
  clickEvent: undefined,
  disabled: false,
  onDisabledClick: () => {},
  noHoverStyle: false,
}

export default SmartLink
